document.addEventListener("DOMContentLoaded", function () {
    if (!window.googleTagManagerService) {
        return;
    }

    function findTarget(event, targetNodeName = 'A') {
        let target = event.target || event.srcElement;
        targetNodeName = targetNodeName.toUpperCase();
        while (target && target.nodeName !== targetNodeName) {
            target = target.parentNode;
        }
        return target;
    }

    document.querySelectorAll('a.card__media').forEach((element) => {
        element.addEventListener('click', function (event) {
            event.preventDefault();
            const target = findTarget(event, 'A');

            if (target && target.dataset.list_id) {
                // If collection page
                googleTagManagerService.selectProduct({
                    id: target.dataset.product_id,
                    name: target.dataset.product_name,
                    category: target.dataset.product_category,
                    index: parseInt(target.dataset.product_index),
                    list_id: target.dataset.list_id,
                    list_name: target.dataset.list_name,
                });
            }

            window.location = target.href;
        });
    });

    document.querySelectorAll('#customer_login').forEach((element) => {
        element.addEventListener('submit', function () {
            const email = ((element.querySelector('#CustomerEmail') || {}).value || "").trim();
            const password = ((element.querySelector('#CustomerPassword') || {}).value || "").trim();
            if (email && password) {
                googleTagManagerService.login();
            }
        });
    });

    document.querySelectorAll('#create_customer').forEach((element) => {
        element.addEventListener('submit', function () {
            const firstname = ((element.querySelector('input[name="customer[first_name]"]') || {}).value || "").trim();
            const lastname = ((element.querySelector('input[name="customer[last_name]"]') || {}).value || "").trim();
            const email = ((element.querySelector('input[name="customer[email]"]') || {}).value || "").trim();
            const password = ((element.querySelector('input[name="customer[password]"]') || {}).value || "").trim();
            if (firstname && lastname && email && password) {
                googleTagManagerService.signUp();
            }
        });
    });

    document.querySelectorAll('#cart_form .remove_item').forEach((element) => {
        element.addEventListener('click', function (event) {
            const target = findTarget(event, 'P');
            if (target) {
                googleTagManagerService.removeFromCartByVariantId(target.dataset.variant_id, target.dataset.quantity);
            }
        });
    });

    document.querySelectorAll('#cart_form p input.quantity').forEach((element) => {
        element.addEventListener('change', function (event) {
            const target = findTarget(event, 'INPUT');
            if (target) {
                const quantity = parseInt(target.value);
                if (quantity === 0) {
                    googleTagManagerService.removeFromCartByLineId(target.dataset.lineId, 1);
                }
            }
        });
    });

    document.addEventListener('cart:updated', (event) => {
        googleTagManagerService.cartData(JSON.parse(event.detail.cart));
    });

    googleTagManagerService.observeClassChange(
        document.querySelector('cart-drawer > details'),
        (classList, node) => {
            if (classList.contains('menu-opening')) {
                // Delay view cart, in order to manage correctly add to cart event
                setTimeout(googleTagManagerService.viewCart, 500);
            }
        }
    );
});